// client/src/pages/user/TicketView.js
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api/axiosInstance";

export default function TicketView() {
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);

  useEffect(() => {
    api.get(`/tickets/${id}`).then(res => setTicket(res.data));
  }, [id]);

  if (!ticket) return <div>Loading ticket…</div>;

  return (
    <div className="space-y-4 max-w-3xl">
      <h1 className="text-xl font-bold">{ticket.subject}</h1>

      <div className="card-glass p-4">
        {ticket.message}
      </div>

      {ticket.replies.map((r, i) => (
        <div
          key={i}
          className={`p-3 rounded ${
            r.byAdmin ? "bg-purple-600/20" : "bg-blue-600/20"
          }`}
        >
          {r.message}
        </div>
      ))}

      <div className="text-sm text-gray-400">
        Status: {ticket.status}
      </div>
    </div>
  );
}
